import React, { useState } from "react";

const riddles = [
    {
        question: "Ho chiavi ma nessuna serratura. Ho spazio ma nessuna stanza. Puoi entrare ma non uscire. Cosa sono?",
        answer: "TASTIERA",
        hint: "La usi ogni giorno per scrivere codice..."
    },
    {
        question: "Più ne togli, più grande divento. Cosa sono?",
        answer: "BUCO",
        hint: "Pensaci letteralmente..."
    },
    {
        question: "Vado su e giù ma non mi muovo mai. Cosa sono?",
        answer: "SCALA",
        hint: "La puoi salire o scendere..."
    }
];

export default function BrainTeaser() {
    const [current, setCurrent] = useState(0);
    const [answer, setAnswer] = useState("");
    const [score, setScore] = useState(0);
    const [done, setDone] = useState(false);
    const [started, setStarted] = useState(false);
    const [showHint, setShowHint] = useState(false);
    const [feedback, setFeedback] = useState("");

    const check = () => {
        if (answer.toUpperCase() === riddles[current].answer) {
            setScore(score + 1);
            setFeedback("✓ Corretto!");
            setTimeout(() => {
                if (current + 1 < riddles.length) {
                    setCurrent(current + 1);
                    setAnswer("");
                    setShowHint(false);
                    setFeedback("");
                } else {
                    setDone(true);
                }
            }, 1500);
        } else {
            setFeedback("✗ Riprova!");
            setTimeout(() => setFeedback(""), 1000);
        }
    };

    if (!started) {
        return (
            <div style={{textAlign:"center",padding:"1rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"0.5rem"}}>
                    <i className="fas fa-lightbulb" style={{marginRight:"6px"}}></i> Brain Teaser
                </h4>
                <p style={{fontSize:"0.85rem",marginBottom:"1rem"}}>Risolvi gli indovinelli!</p>
                <button onClick={() => setStarted(true)} style={{background:"linear-gradient(135deg,#facc15,#ca8a04)",border:"none",color:"#000",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (done) {
        return (
            <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
                <h4 style={{color:"#facc15",marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Completato!
                </h4>
                <p style={{fontSize:"1.5rem",fontWeight:"700",color:"#22c55e",marginBottom:"1rem"}}>
                    {score}/{riddles.length}
                </p>
                <p style={{fontSize:"0.9rem",marginBottom:"1.5rem"}}>
                    {score === riddles.length && "🧠 Genio!"}
                    {score === 2 && "👍 Ben fatto!"}
                    {score < 2 && "💡 Riprova!"}
                </p>
                <button onClick={() => {setStarted(true);setCurrent(0);setScore(0);setDone(false);setAnswer("");setShowHint(false);}} style={{background:"linear-gradient(135deg,#16a34a,#065f46)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:"pointer"}}>
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{textAlign:"center",padding:"1.5rem",color:"#e5e7eb",background:"rgba(255,255,255,0.05)",borderRadius:"1rem",boxShadow:"0 0 25px rgba(0,255,200,0.15)"}}>
            <div style={{marginBottom:"1rem",color:"#94a3b8",fontSize:"0.85rem"}}>
                Indovinello {current + 1} di {riddles.length} - Punteggio: {score}
            </div>
            <p style={{fontSize:"0.95rem",marginBottom:"1.5rem",lineHeight:"1.5",color:"#facc15"}}>
                {riddles[current].question}
            </p>
            <button onClick={() => setShowHint(!showHint)} style={{marginBottom:"1rem",background:"rgba(59,130,246,0.2)",border:"1px solid rgba(59,130,246,0.3)",color:"#3b82f6",fontWeight:"700",padding:"0.5rem 1rem",borderRadius:"0.5rem",cursor:"pointer",fontSize:"0.8rem"}}>
                <i className="fas fa-lightbulb" style={{marginRight:"6px"}}></i> {showHint ? "Nascondi" : "Mostra"} Hint
            </button>
            {showHint && <div style={{padding:"0.8rem",background:"rgba(59,130,246,0.1)",borderRadius:"0.5rem",marginBottom:"1rem",fontSize:"0.8rem",color:"#94a3b8",border:"1px solid rgba(59,130,246,0.3)"}}>
                💡 {riddles[current].hint}
            </div>}
            <input type="text" value={answer} onChange={(e) => setAnswer(e.target.value)} onKeyPress={(e) => e.key === "Enter" && answer && check()}
                   style={{width:"100%",padding:"0.8rem",borderRadius:"0.5rem",border:"2px solid rgba(255,255,255,0.1)",background:"rgba(255,255,255,0.05)",color:"#fff",fontSize:"1rem",textAlign:"center",outline:"none",marginBottom:"1rem"}}
                   placeholder="LA TUA RISPOSTA..." />
            {feedback && <div style={{fontSize:"1.2rem",color:feedback.includes("✓")?"#22c55e":"#ef4444",fontWeight:"700",marginBottom:"1rem"}}>{feedback}</div>}
            <button onClick={check} disabled={!answer} style={{background:answer?"linear-gradient(135deg,#2563eb,#1e40af)":"rgba(255,255,255,0.1)",border:"none",color:"#fff",fontWeight:"700",padding:"0.6rem 1.2rem",borderRadius:"0.5rem",cursor:answer?"pointer":"not-allowed",opacity:answer?1:0.5,width:"100%"}}>
                <i className="fas fa-check" style={{marginRight:"6px"}}></i> Verifica
            </button>
        </div>
    );
}